"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PersonCategoryFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _fields = require("../../fields");

var _personCategoryConfig = require("./personCategoryConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var PersonCategoryDefinition = _flowRuntime["default"].tdz(function () {
  return _personCategoryConfig.PersonCategoryDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("donorChecked", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("formSyncErrors", _flowRuntime["default"].object(), true), _flowRuntime["default"].property("personCategory", _flowRuntime["default"].ref(PersonCategoryDefinition)), _flowRuntime["default"].property("queryParams", _flowRuntime["default"].object(), true), _flowRuntime["default"].property("resetDonorId", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("resetSupporterId", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("setDonorId", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"].param("_arg1", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("setSupporterId", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"].param("_arg1", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("supporterChecked", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("touchDonorId", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("touchSupporterId", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]())))));

var PersonCategoryFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PersonCategoryFields, _React$Component);

  var _super = (0, _createSuper2["default"])(PersonCategoryFields);

  function PersonCategoryFields() {
    (0, _classCallCheck2["default"])(this, PersonCategoryFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _super.call.apply(_super, [this].concat(args));
  }

  (0, _createClass2["default"])(PersonCategoryFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          queryParams = _this$props.queryParams,
          setDonorId = _this$props.setDonorId,
          setSupporterId = _this$props.setSupporterId,
          componentKey = _this$props.componentKey,
          touchDonorId = _this$props.touchDonorId,
          touchSupporterId = _this$props.touchSupporterId;
      var queryDonorId = queryParams && queryParams.donorId;
      var querySupporterId = queryParams && queryParams.supporterId;

      if (queryDonorId) {
        setDonorId(componentKey, queryDonorId);
        touchDonorId(componentKey);
      }

      if (querySupporterId) {
        setSupporterId(componentKey, querySupporterId);
        touchSupporterId(componentKey);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
          resetDonorId = _this$props2.resetDonorId,
          resetSupporterId = _this$props2.resetSupporterId,
          donorChecked = _this$props2.donorChecked,
          supporterChecked = _this$props2.supporterChecked,
          componentKey = _this$props2.componentKey;

      if (!donorChecked) {
        resetDonorId(componentKey);
      }

      if (!supporterChecked) {
        resetSupporterId(componentKey);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          componentKey = _this$props3.componentKey,
          donorChecked = _this$props3.donorChecked,
          formSyncErrors = _this$props3.formSyncErrors,
          personCategory = _this$props3.personCategory,
          queryParams = _this$props3.queryParams,
          supporterChecked = _this$props3.supporterChecked;
      var queryDonorId = queryParams && queryParams.donorId;
      var querySupporterId = queryParams && queryParams.supporterId;
      var donorIdError = formSyncErrors && formSyncErrors[componentKey] && formSyncErrors[componentKey].donorId;
      var supporterIdError = formSyncErrors && formSyncErrors[componentKey] && formSyncErrors[componentKey].supporterId;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: queryDonorId && !donorIdError || querySupporterId && !supporterIdError ? 'hidden' : ''
      }, /*#__PURE__*/_react["default"].createElement(_fields.Checkbox, {
        checkbox: _personCategoryConfig.supporter,
        disabled: !!querySupporterId,
        key: _personCategoryConfig.supporter.key
      }), supporterChecked && /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
        disabled: !!querySupporterId,
        key: _personCategoryConfig.supporterId.key,
        textfield: _personCategoryConfig.supporterId,
        inheritedFieldValidation: personCategory.inheritedFieldValidation
      }), /*#__PURE__*/_react["default"].createElement(_fields.Checkbox, {
        checkbox: _personCategoryConfig.donor,
        disabled: !!queryDonorId,
        key: _personCategoryConfig.donor.key
      }), donorChecked && /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
        disabled: !!queryDonorId,
        key: _personCategoryConfig.donorId.key,
        textfield: _personCategoryConfig.donorId,
        inheritedFieldValidation: personCategory.inheritedFieldValidation
      }));
    }
  }]);
  return PersonCategoryFields;
}(_react["default"].Component);

exports.PersonCategoryFields = PersonCategoryFields;
PersonCategoryFields.defaultProps = {
  formSyncErrors: {},
  queryParams: undefined
};
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    formSyncErrors: (0, _reduxForm.getFormSyncErrors)('form')(state),
    donorChecked: selector(state, "".concat(componentKey, ".donor")),
    supporterChecked: selector(state, "".concat(componentKey, ".supporter"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetDonorId: function resetDonorId(componentKey) {
      return dispatch((0, _reduxForm.change)('form', "".concat(componentKey, ".donorId"), ''));
    },
    resetSupporterId: function resetSupporterId(componentKey) {
      return dispatch((0, _reduxForm.change)('form', "".concat(componentKey, ".supporterId"), ''));
    },
    setDonorId: function setDonorId(componentKey, donorIdString) {
      Promise.all([dispatch((0, _reduxForm.change)('form', "".concat(componentKey, ".donor"), true)), dispatch((0, _reduxForm.change)('form', "".concat(componentKey, ".donorId"), donorIdString))]);
    },
    setSupporterId: function setSupporterId(componentKey, supporterIdString) {
      Promise.all([dispatch((0, _reduxForm.change)('form', "".concat(componentKey, ".supporter"), true)), dispatch((0, _reduxForm.change)('form', "".concat(componentKey, ".supporterId"), supporterIdString))]);
    },
    touchDonorId: function touchDonorId(componentKey) {
      return dispatch((0, _reduxForm.touch)('form', "".concat(componentKey, ".donorId")));
    },
    touchSupporterId: function touchSupporterId(componentKey) {
      return dispatch((0, _reduxForm.touch)('form', "".concat(componentKey, ".supporterId")));
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PersonCategoryFields);

exports["default"] = _default;